import { render, staticRenderFns } from "./on_ramp.vue?vue&type=template&id=3422829b"
import script from "./on_ramp.vue?vue&type=script&lang=js"
export * from "./on_ramp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports